// extracted by mini-css-extract-plugin
export default {"fieldGroupSpacing":"OtherFieldsGroup_fieldGroupSpacing__Io5GC"};